import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, NgForm, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AuthService } from '../_services/auth.service';
import { LoadingService } from '../_services/loading.service';
import { NavService } from '../_services/nav.service';
import { NotificationService } from '../_services/notification.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  pwdBoxHide = true;
  email: string;
  password: string;

  constructor(
    private titleService: Title,
    private formBuilder: FormBuilder,
    private loading: LoadingService,
    private authService: AuthService,
    private breakpointObserver: BreakpointObserver,
    private navService: NavService,
    private router: Router,
    private route: ActivatedRoute,
    private loadingBar: LoadingBarService,
    private notificationService: NotificationService,
  ) {
    this.loginForm = formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  ngOnInit() {
    //this.loading.spin$.next(true);
    this.titleService.setTitle('User Login!!');
  }

  login(loginForm: any) {
    if (loginForm.valid) {
      this.loading.spin$.next(true);
      var result = this.authService.login(loginForm.controls.email.value, loginForm.controls.password.value)
        .subscribe(data => {
          console.log(data);
          if (JSON.stringify(data['access_token'])) {
            //console.log(data['dschool_access_token']);
            localStorage.setItem('dschool_id_token', data['access_token']);
            this.authService.bindNavbar(data['user']);
            this.authService.isLogin = true;
            // get return url from query parameters or default to home page
            const returnUrl = this.route.snapshot.queryParams['returnUrl'];
            if (returnUrl) {
              this.router.navigateByUrl(returnUrl);
            }
            else {
              let role = data['user'].role;
              // this.router.navigateByUrl('/chemistshop');
              // this.router.navigateByUrl('/leadcrm/leads');
              this.router.navigateByUrl('/ecom/orders');
              // this.router.navigateByUrl('/ecom');
            }
            this.loginForm.reset();
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error(data['error_message']);
            console.log(data);
            this.loading.spin$.next(false);
            //this.loadingBar.complete();
          }
        });
    }
  }





}
